module.exports = __webpack_public_path__ + "media/חורף.0fbeefed.mp3";